import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/ai-models-photoshoot",
};
